export const TeamLink = ({
  teamName,
  teamId,
}: {
  teamName: string;
  teamId: number;
}) => {
  return (
    <a
      href={`/dashboard/teams/view/${teamId}`}
      className="font-medium text-blue-600 hover:text-blue-800 hover:underline focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 rounded-sm transition-all duration-200"
    >
      {teamName}
    </a>
  );
};
